import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { APP_INITIALIZER, enableProdMode } from "@angular/core";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field";
import { bootstrapApplication } from "@angular/platform-browser";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideRouter } from "@angular/router";
import appRoutes from "@app/app.routes";
import { CountryListResponse } from "@models/country.model";
import { AppStateService, RequestService } from "@services/index";
import { provideCharts, withDefaultRegisterables } from "ng2-charts";
import { firstValueFrom } from "rxjs";
import { AppComponent } from "./app/app.component";
import { httpInterceptorProviders } from "./app/interceptors";
import { environment } from "./environments/environment";

if (environment.production) {
  enableProdMode();
}

function initializeAppFactory(requestService: RequestService, appStateService: AppStateService) {
  return async () => {
    try {
      // Hydrate auth state (userToken$/currentUser$) from the `ab_session`
      // cookie before the app renders, so AuthGaurd/AppComponent never see a
      // stale "logged out" flash. checkSession() never throws — it resolves
      // false on an invalid/missing cookie — but this is still guarded in
      // case of an unexpected network error.
      await firstValueFrom(appStateService.bootstrapSession());
    } catch (error) {
      console.error("Error bootstrapping session:", error);
    }
    try {
      // Get countries
      const countriesRes = await firstValueFrom(
        requestService.get<CountryListResponse>("/api/v2/country")
      );
      if (countriesRes.status === true) {
        appStateService.allCountries.set(countriesRes.data);
      }
    } catch (error) {
      console.error("Error initializing app:", error);
    }
  };
}

bootstrapApplication(AppComponent, {
  providers: [
    httpInterceptorProviders,
    provideAnimations(),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptorsFromDi()),
    provideCharts(withDefaultRegisterables()),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: "outline", floatLabel: "always" },
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppFactory,
      deps: [RequestService, AppStateService],
      multi: true,
    },
  ],
});
